import OneTimeOrderPayment from './OneTimeOrderPayment';

export default OneTimeOrderPayment;
